import { $k18n } from '@/common/i18n';
import React from 'react';
import { StyleProp, Text, TextProps, TextStyle, View, ViewStyle } from 'react-native';

// 多语言——参数可以直接为jsx元素
interface k18nProProps {
    text?: string;
    id?: string;
    noRunK18n?: boolean;
    params?: {
        [key: string]: JSX.Element | string | Number;
    };
    outerStyle?: StyleProp<TextStyle>;
}

export const k18nPro = (k18n: k18nProProps & Partial<TextProps>) => {
    const { id, params, outerStyle, text, noRunK18n = false } = k18n;
    if (!id && !text) return <Text {...k18n} />;
    const resLang = noRunK18n ? id || text : id ? $k18n({ id }) : $k18n({ text });
    let _resLang = resLang;
    const texts = [];
    const split = ['{', '}'];
    let start = 0;
    let index = _resLang.indexOf(split[start % 2]);
    while (index >= 0) {
        const sub = _resLang.slice(0, index + (start % 2));
        _resLang = _resLang.slice(index + (start % 2));
        start++;
        index = _resLang.indexOf(split[start % 2]);
        texts.push(sub);
    }
    if (_resLang.length > 0) texts.push(_resLang);
    const regex = /{[^{}]*}/g;
    const foundParams = resLang.match(regex) || ([] as string[]); // > Array ["{x}", "{y}"]
    const _foundParams = foundParams.map(x => x.substring(1, x.length - 1)); // > Array ['x', 'y']
    return (
        <Text style={outerStyle} {...k18n}>
            {texts.map(text => {
                const i = foundParams.indexOf(text);
                if (i > -1) return params?.[_foundParams[i]] || text;
                else return text;
            })}
        </Text>
    );
};

/**
 * 将多语言中的&1进行替换, 替换成Text包裹
 */
export function k18nProV2(
    str: string,
    style: {
        outerStyle: StyleProp<TextStyle>;
        innerStyle: StyleProp<TextStyle>;
    }
) {
    if (!str) return str;
    const reg = /(.+)?&1(.+)&1(.+)?/;
    const res = str.match(reg);
    if (res) {
        const [_, s1, s2, s3] = res;
        return (
            <Text style={style.outerStyle}>
                {s1 ? <>{s1}</> : null}
                {s2 ? <Text style={style.innerStyle}>{s2}</Text> : null}
                {s3 ? <>{s3}</> : null}
            </Text>
        );
    }
    return <Text style={style.outerStyle}>{str}</Text>;
}
